import { FilterOperator } from "@/lib/filters/FilterOperator";

/**
 * Regular expression used to match filter operators.
 */
export const filterOperatorRegExp = new RegExp(
  `\\s+(${Object.values(FilterOperator).join("|")})\\s+`,
);
